export const FETCH_SAFESCARF_USERS_STARTED = 'FETCH_SAFESCARF_USERS_STARTED' as const;
export const FETCH_SAFESCARF_USERS_FULFILLED = 'FETCH_SAFESCARF_USERS_FULFILLED' as const;
export const CREATE_SAFESCARF_USER_STARTED = 'CREATE_SAFESCARF_USER_STARTED' as const;
export const CREATE_SAFESCARF_USER_FULFILLED = 'CREATE_SAFESCARF_USER_FULFILLED' as const;
export const UPDATE_SAFESCARF_USER_STARTED = 'UPDATE_SAFESCARF_USER_STARTED' as const;
export const UPDATE_SAFESCARF_USER_FULFILLED = 'UPDATE_SAFESCARF_USER_FULFILLED' as const;

export const fetchUsers = (params: unknown) => ({ type: FETCH_SAFESCARF_USERS_STARTED, payload: params });

export const fetchUsersFulfilled = (data: unknown) => ({
  type: FETCH_SAFESCARF_USERS_FULFILLED,
  payload: data,
});

export const createUser = (data: unknown) => ({ type: CREATE_SAFESCARF_USER_STARTED, payload: data });

export const createUserFulfilled = (data: unknown) => ({
  type: CREATE_SAFESCARF_USER_FULFILLED,
  payload: data,
});

export const updateUser = (data: unknown) => ({ type: UPDATE_SAFESCARF_USER_STARTED, payload: data });

export const updateUserFulfilled = (data: unknown) => ({
  type: UPDATE_SAFESCARF_USER_FULFILLED,
  payload: data,
});
